import { ChargingStationDetail } from '@shared/models/business/chargingStationDetail';

export class EnergyCost {
	cost: number;
	yearlyInflation: number;
	adblue?: number;
	dieselCost?: number;
	chargingStationList: ChargingStationDetail[];
}
